import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 60_000, refetchOnWindowFocus: false },
    },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>,
);

// Register service worker (PWA offline shell).
// First install: trigger a one-time reload after the SW takes control so the
// initial visit's JS/CSS get captured by the SW (otherwise the very first
// offline visit can be blank).
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        const hadController = !!navigator.serviceWorker.controller;

        navigator.serviceWorker
            .register("/service-worker.js")
            .then(() => {
                // When a new SW takes over (or the very first one installs),
                // reload exactly once so the page is served by the SW and all
                // assets are cached for offline use.
                if (!hadController) {
                    navigator.serviceWorker.addEventListener("controllerchange", () => {
                        if (sessionStorage.getItem("rom_sw_first_reload") === "1") return;
                        sessionStorage.setItem("rom_sw_first_reload", "1");
                        window.location.reload();
                    });
                }
            })
            .catch((err) => console.warn("SW registration failed:", err));
    });
}
